class ScrollService {
  private static serviceInstance: ScrollService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public scrollToTop(): void {
    setTimeout(() => {
      window.scroll({
        top: 0,
        left: 0
      });
    }, 100);
  }

  public scrollToElementId(elementId: string): void {
    const element = document.getElementById(elementId);

    if (element) {
      element.scrollIntoView();
    }
  }

  public disableBodyScroll(): void {
    document.body.style.position = 'fixed';
    document.body.style.top = '0';
    document.body.style.left = '0';
    document.body.style.right = '0';
  }

  public allowBodyScroll(): void {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const scrollService = ScrollService.instance;
